import firebase from 'firebase/app';
import 'firebase/auth';
import { createCard } from 'src/core/models/card';
export const SESSION_LOGIN = 'SESSION_LOGIN';
export const SESSION_LOGOUT = 'SESSION_LOGOUT';
export const SESSION_ORGANIZATION_RESOLVED = 'SESSION_ORGANIZATION_RESOLVED';
export const SESSION_LOGIN_ATTEMPT = 'SESSION_LOGIN_ATTEMPT';
export const SESSION_LOGIN_FAILED = 'SESSION_LOGIN_FAILED';
export const SESSION_ADD_TO_CART = 'SESSION_ADD_TO_CART';
export const SESSION_UPDATE_CART = 'SESSION_UPDATE_CART';
export const SESSION_REMOVE_FROM_CART = 'SESSION_REMOVE_FROM_CART';
export const SESSION_SET_CARD = 'SESSION_SET_CARD';

export const login = user => dispatch =>
  dispatch({
    type: SESSION_LOGIN,
    payload: user,
  });

export const logout = () => async dispatch => {
  try {
    await firebase.auth().signOut();
    dispatch({
      type: SESSION_LOGOUT,
    });
  } catch (e) {
    console.log(e);
  }
};

export const setCard = (card) => dispatch => {
  dispatch({ type: SESSION_SET_CARD, payload: card });

}

export const resolveOrganization = organization => async dispatch => {
  dispatch({ type: SESSION_ORGANIZATION_RESOLVED, payload: organization });
};

export const initAuth = () => dispatch => {
  dispatch({ type: SESSION_LOGIN_ATTEMPT });
  firebase.auth().onAuthStateChanged(authUser => {
    if (!authUser) {
      dispatch(logout());
    } else {
      firebase
        .firestore()
        .collection('users')
        .doc(authUser.uid)
        .get()
        .then(async doc => {
          if (doc.exists) {
            if (doc.data().role !== 'customer') {
              firebase
                .firestore()
                .collection('organizations')
                .where('owners', 'array-contains', doc.id)
                .onSnapshot(snap => {
                  const [org] = snap.docs;
                  if (org) {
                    dispatch(
                      resolveOrganization({ id: org.id, ...org.data() } || {})
                    );
                  }
                  dispatch(login({ ...doc.data(), uid: doc.id }));
                });
            } else {
              firebase
                .firestore()
                .collection('organizations')
                .where('name', '==', 'arcatalog')
                .get()
                .then(snap => {
                  const [org] = snap.docs;
                  if (org) {
                    dispatch(
                      resolveOrganization({ id: org.id, ...org.data() } || {})
                    );
                  }
                  dispatch(login({ ...doc.data(), uid: doc.id }));
                });
              const userCards = await firebase
                .firestore()
                .collection('cards')
                .where('user.uid', '==', doc.id)
                .get();
              if (!userCards.docs.length) {
                await createCard({
                  user: {
                    uid: authUser.uid,
                    displayName: authUser.displayName,
                    email: authUser.displayName,
                  },
                });
              }
              dispatch(login({ ...doc.data(), uid: doc.id }));
            }
          } else {
            dispatch(logout());
          }
        })
        .catch(console.error);
    }
  });
};

export const addToCart = item => async dispatch => {
  dispatch({ type: SESSION_ADD_TO_CART, payload: {item}});
};

export const updateCart = (item, count) => async dispatch => {
  dispatch({ type: SESSION_UPDATE_CART, payload: {item, count}});
};

export const RemoveFromCart = item => async dispatch => {
  dispatch({ type: SESSION_REMOVE_FROM_CART, payload: {item}});
};